<template>
  <!-- <div id="header-profilo" v-on:tap="goToProfile()"> -->
  <div id="header-profilo" v-on:tap.stop="onProfileClick">
    <div>
      <div class="header-image-container" v-bind:style="{backgroundImage: 'url('+userImage+')'}">
        <div class="icon-more-container">
          <div v-if="!user">
<!--            <i class="rds-icon rds-icon-morewhite" v-on:tap.stop="onIconMoreClick"></i>-->
            <!-- <RdsFileUploader v-on:fileUploaded="onFileUploaded"></RdsFileUploader> -->
          </div>
        </div>
      </div>

      <div id="info-utente">
        <h3>{{currentUser.name}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../services/User.service';
import { eventBus } from '../services/EventBus';
export default {
  name: 'home',
  props: ['user'],
  data() {
    return {
      img: require('../assets/images/Foto_profilo.jpg'),
      userService: userService
    };
  },
  computed: {
    currentUser() {
      return this.user || userService.user;
    },
    userImage() {
      const DEFAULT_IMG =
        'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/default-user.jpg';

      if (
        this.currentUser.photos[0] !== DEFAULT_IMG &&
        this.currentUser.photos[0].indexOf('googleusercontent') === -1
      ) {
        return this.currentUser.photos[0];
      } else {
        return require('../assets/images/img_segnaposto_home_profilo.png');
        // return require('../assets/images/placeholder_img_profilo.svg');
      }
    }
  },
  methods: {
    onFileUploaded(file) {
      this.$emit('editMode', file);
    },
    goToProfile() {
      if (this.$route.name !== 'profile') {
        this.$router.push('/profile');
      }
    },
    onProfileClick(e) {
      if (this.$route.name === 'home') {
        eventBus.$emit('toogleMenuProfile');
      }
    },
    onIconMoreClick(e) {
      eventBus.$emit('toogleMenuProfile');
    }
  }
};
</script>
<style lang="scss" scoped>
#header-profilo > div {
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 0.95em;
  #info-utente {
    position: absolute;
    bottom: 20px;
    left: 20px;
    color: white;
    font-size: 1em;
    h3 {
      font-size: 0.95em;
      font-weight: 500;
      margin: 0;
      letter-spacing: 1px;
    }
  }
  .header-image-container {
    width: 100%;
    height: 192px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: 50%;
    position: relative;
    &:after {
      content: '';
      background-image: url('../assets/images/gradient3.png');
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 1;
      background-repeat: no-repeat;
      z-index: 0;
      background-position: bottom;
      background-size: cover;
    }
  }
}
.icon-more-container {
  color: white;
  font-size: 0.7em;
  display: flex;
  justify-content: flex-end;
  z-index: 3;
  position: relative;
  margin: 11px 13px 0 0px;
  .rds-icon-morewhite {
    font-size: 0.5em;
  }
  div {
    position: relative;
    margin: 4px;
  }
}
</style>
